import { createSlice } from '@reduxjs/toolkit';
import { IRequestForm } from '../../types/requestForm';

const initialState: IRequestForm = {
  showRequestForm: false,
  requiresAuth: false,
};

export const requestFormSlice = createSlice({
  name: 'requestForm',
  initialState,
  reducers: {},
});

export const { reducer: requestFormReducer } = requestFormSlice;
